import { get, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@commonsku/styles';
import { calculateAvalaraTax } from '../actions/tax';
import { useAvalara } from './avalara/hooks';
import AddressErrorPopup from './avalara/AddressErrorPopup';
import { useSplitShip } from "./split-ship/useSplitShip";
import SetupSplitShipButton from "./split-ship/SetupSplitShipButton";
import { createSplitShipPopup } from '../actions/popup';
import PropTypes from 'prop-types';

const AvalaraOrderTaxButton = ({ order, showSplitship, disableSplitShip }) => {
  const avalara = useAvalara();
  const locked = 1 == order.locked;
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const [addressResolution, setAddressResolution] = useState(null);
  const handleShowSplitship = e => {
    e?.preventDefault();
    dispatch(createSplitShipPopup(order.order_id, {
      isLocked: locked,
    }));
  };
  const { accessible } = useSplitShip(order.order_id);
  const sharedButtonSpaceProps = accessible ? { size: "small", style: { marginLeft: 8 } } : {};

  return <tr key="calculateTaxButton" className="totals">
    <td colSpan="2">
      {<SetupSplitShipButton
        order_id={order.order_id}
        disabled={locked || disableSplitShip}
        onClick={handleShowSplitship}
      />}
      {!showSplitship && order.avalara_status === "" && <Button {...sharedButtonSpaceProps} disabled={locked || disableSplitShip} onClick={() => {
        setError(null);
        setAddressResolution(null);
        avalara.resolveAddress({ order_id: order.order_id })
          .then(({ json }) => {
            if (json.error) {
              setError(json.error);
            } else if (!isEmpty(get(json, 'address_resolution.messages'))) {
              setAddressResolution(json.address_resolution);
            } else {
              return false;
            }
            return true;
          })
          .then((hasError) => {
            if (!hasError) {
              return dispatch(calculateAvalaraTax(order.order_id));
            }
          })
          .catch(({ json }) => {
            setError(json.error);
          })
          ;
      }}>Calculate Tax</Button>}
      {(!isEmpty(error) || !isEmpty(addressResolution)) && <AddressErrorPopup
        error={error}
        resolution={addressResolution}
        onClose={() => {
          setError(null);
          setAddressResolution(null);
        }}
        ignoreError={() => {
          dispatch(calculateAvalaraTax(order.order_id)).catch(({ json }) => {
            setError(json.error);
          });
        }}
      />}
    </td>
  </tr>;
};

AvalaraOrderTaxButton.propTypes = {
  order: PropTypes.shape({
    order_id: PropTypes.string.isRequired,
    locked: PropTypes.number,
    avalara_status: PropTypes.string,
  }).isRequired,
  showSplitship: PropTypes.bool,
  disableSplitShip: PropTypes.bool,
};

export default React.memo(AvalaraOrderTaxButton);